import { useEffect, useState } from "react";
import { assetUrl } from "../lib/api";

const FALLBACK_IMAGE = "/product-placeholder.svg";

export function ProductImage({ alt, className, src, testId, width = 400, height = 400 }) {
  const resolved = assetUrl(src);
  const [failed, setFailed] = useState(!resolved);

  useEffect(() => {
    setFailed(!resolved);
  }, [resolved]);

  return (
    <img
      src={failed || !resolved ? FALLBACK_IMAGE : resolved}
      alt={alt}
      width={width}
      height={height}
      loading="lazy"
      decoding="async"
      className={className}
      data-testid={testId}
      onError={() => setFailed(true)}
    />
  );
}
